import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { libraryShape, stackMapShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectStackMapData, selectStackMapTransactions } from 'app/selectors/StackMapSelector';
import StackMapDisplay from './StackMapDisplay';

export function StackMapDisplayContainer(props) {
  return props.stackMap && <StackMapDisplay {...props} />;
}

StackMapDisplayContainer.propTypes = {
  currentLibrary: libraryShape.isRequired,
  stackMap: stackMapShape,
  stackMapTransactions: ImmutablePropTypes.mapContains({
    open: PropTypes.bool,
    noResults: PropTypes.bool,
    isFetching: PropTypes.bool
  }).isRequired
};

const mapStateToProps = state => {
  return {
    stackMap: selectStackMapData(state),
    stackMapTransactions: selectStackMapTransactions(state),
    currentLibrary: selectCurrentLibrary(state)
  };
};

export default connect(mapStateToProps)(StackMapDisplayContainer);
